import type { FormSectionProps } from './FormSection'
import FormSection from './FormSection'

export type { FormSectionProps }
export default FormSection
